export default {
  getProdutoForca(state) {
    return state.produto
  }
}
